<template>
  <div class="layout-header">
    <div class="page-logo-wrapper">
      <img src="../../assets/img/page_logo.png" alt="" srcset="" class="logo-img-wrapper">
    </div>
    <div class="header-right-wrapper">
      <div class="navbar-wrapper">
        <ul>
          <li class="navbar-txt" :class="{'active': navIndex==index||routeId==navItem.id}" v-for="(navItem,index) in navbarList" :key="index" @click="changeNavbar(navItem,index)">{{navItem.title}}</li>
        </ul>
        <div class="nav-line-wrapper">
          <div class="line"></div>
        </div>
      </div>
      <div class="user-account-wrapper">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            {{userName}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item disabled>{{roleName}}</el-dropdown-item>
            <el-dropdown-item command="modidfyPassword">修改密码</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      navIndex: 0,
      navItemWidth: 0,
      navLeftWidth: 0,
      userName: "zengjielin",
      roleName: "角色名称",
      navbarList: [],
      routeId: "",
      navbarIdList: []
    };
  },
  methods: {
    ...mapActions({
      _logout: "logout"
    }),
    changeNavbar(navItem, index) {
      // 改变头部的导航栏同时改变侧边栏
      this.$root.eventHub.$emit("navRoutePath", navItem.children[0].path);
      this.$router.push({ path: navItem.children[0].path });
      this.navIndex = index;
      for (
        let i = 0;
        i < document.querySelectorAll(".navbar-txt").length;
        i++
      ) {
        document.querySelectorAll(".navbar-txt")[i].className = "navbar-txt";
      }
      this.navItemWidth = document.querySelectorAll(".navbar-txt")[
        index
      ].clientWidth;
      this.navLeftWidth = 0;
      for (let i = 0; i < index; i++) {
        this.navLeftWidth +=
          document.querySelectorAll(".navbar-txt")[i].clientWidth + 30;
      }
      document.querySelector(".line").style = `left:${
        this.navLeftWidth
      }px;width:${this.navItemWidth}px`;
    },
    async logout() {
      const res = await this._logout();
      if (res.code == 0) {
        this.$message.success("成功退出账号");
      }
    },
    handleCommand(command) {
      if (command == "modidfyPassword") {
        this.$root.eventHub.$emit("passwordDialog");
      }
      if (command == "logout") {
        this.$router.push({ name: "Login" });
        this.logout();
      }
    }
  },
  created() {
    if (sessionStorage.getItem("accountInfo")) {
      this.userName = JSON.parse(
        sessionStorage.getItem("accountInfo")
      ).username;
      this.roleName = JSON.parse(
        sessionStorage.getItem("accountInfo")
      ).role_name;
    }
    // 侧边栏数据
    this.$root.eventHub.$on("menuList", data => {
      let indexData = {};
      if (sessionStorage.getItem("accountInfo")) {
        let accountInfo = JSON.parse(sessionStorage.getItem("accountInfo"));
        if (accountInfo.account_type == 3) {
          indexData = {
            title: "首页",
            id: "300",
            icon: "",
            path: "/layout_root",
            children: [
              {
                name: "SuperIndex",
                path: "/super/index",
                title: "首页"
              }
            ]
          };
        } else if (accountInfo.account_type == 2) {
          indexData = {
            title: "首页",
            id: "200",
            icon: "",
            path: "/layout_root",
            children: [
              {
                name: "CompanyIndex",
                path: "/merchant/company_index",
                title: "首页"
              }
            ]
          };
        } else if (accountInfo.account_type == 1) {
          indexData = {
            title: "首页",
            id: "100",
            icon: "",
            path: "/layout_root",
            children: [
              {
                name: "ShopIndex",
                path: "/shop/index",
                title: "首页"
              }
            ]
          };
        } else if (accountInfo.account_type == 5) {
          indexData = {
            title: "首页",
            id: "500",
            icon: "",
            path: "/layout_root",
            children: [
              {
                name: "AreaIndex",
                path: "/area/index",
                title: "首页"
              }
            ]
          };
        }
      }
      let sysData = {
        title: "系统中心",
        path: data[0].path,
        id: data[0].id,
        icon: data[0].icon,
        children: data[0].children
      };
      this.navbarList = [indexData, sysData];
      let navbarIdList = [];
      this.navbarList.map(v => {
        navbarIdList.push(v.id);
      });
      this.navbarIdList = navbarIdList;
    });
    // 侧边栏改变导航栏
    this.$root.eventHub.$on("sideRoutePath", data => {
      if (data) {
        this.navIndex = 1;
        this.$nextTick(() => {
          this.navItemWidth = document.querySelectorAll(".navbar-txt")[
            this.navIndex
          ].clientWidth;
          this.navLeftWidth = 0;
          for (let i = 0; i < this.navIndex; i++) {
            this.navLeftWidth +=
              document.querySelectorAll(".navbar-txt")[i].clientWidth + 30;
          }
          document.querySelector(".line").style = `left:${
            this.navLeftWidth
          }px;width:${this.navItemWidth}px`;
        });
      }
    });
  },
  watch: {
    $route(to, from) {
      if (
        to.path == "/" ||
        to.path == "/super/index" ||
        to.path == "/merchant/company_index" ||
        to.path == "/merchant/shop_index" ||
        to.path == "/shop/index"
      ) {
        this.navIndex = 0;

        this.navItemWidth = document.querySelectorAll(".navbar-txt")[
          this.navIndex
        ].clientWidth;
        this.navLeftWidth = 0;
        document.querySelector(".line").style = `left:${
          this.navLeftWidth
        }px;width:${this.navItemWidth}px`;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.navItemWidth = document.querySelectorAll(
        ".navbar-txt"
      )[0].clientWidth;
      document.querySelector(".line").style = `left:${
        this.navLeftWidth
      }px;width:${this.navItemWidth}px`;
    });
  }
};
</script>

<style lang='scss'>
.layout-header {
  height: 60px;
  background: #fff;
  display: flex;
  user-select: none;
  .page-logo-wrapper {
    min-width: 220px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #2694ee;
    .logo-img-wrapper {
      height: 40px;
    }
  }
  .header-right-wrapper {
    flex: 1;
    display: flex;
    align-items: center;
    .navbar-wrapper {
      flex: 1;
      padding: 0 20px;
      box-sizing: border-box;
      ul {
        padding: 0;
        margin: 0;
        list-style: none;
        display: flex;
        align-items: center;
        padding-top: 10px;
        padding-bottom: 6px;
        li {
          margin: 0 30px 0 0;
          transition: all 0.4s ease;
          letter-spacing: 4px;
          cursor: pointer;
          color: #6d7a86;
          font-weight: 600;
        }
        li:hover {
          color: #2694ee;
        }
        .active {
          color: #2694ee;
        }
      }
      .nav-line-wrapper {
        width: 100%;
        height: 2px;
        position: relative;
        .line {
          height: 2px;
          position: absolute;
          bottom: 0;
          margin: 10px 0 0 0;
          background: #2694ee;
          transition-property: width, left;
          transition-duration: 0.4s;
        }
      }
    }
    .user-account-wrapper {
      padding-right: 30px;
      width: 120px;
      text-align: right;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/LayoutHeader.vue